import { Component } from '@angular/core';

@Component({
  templateUrl: 'myaccount.component.html'
})
export class MyaccountComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/users/myaccount.component.ts